(function() {
  'use strict';

  eclipseApp
    /**
     * Geleral setting for Store Locator
     */
    .value('storeLocatorConfig', {
      defaultMaxResults: 50, //Maximum number of results to display (must be <=75)
      defaultLng: -79.37989, //Default Map Longitude
      defaultLat: 43.6715, //Default Map Latitude
      defaultZoom: 13, //Default Map Zoom Level
      refresh: true, //Parameter for google map to refresh
      defaultOptions: { scrollwheel: false, minZoom: 11 },
      defaultShowSearchbox: true,
      // defaultShowPagination: true,
      defaultShowSearchCategory: false,
      defaultShowMap: false,
      //storeLocatorUrl: 'https://www.googleapis.com/mapsengine/v1/',
      //storeLocatorUrl: 'https://1-dot-rogers-store-finder.appspot.com/rogers_store_finder',
      storeLocatorUrl: 'https://1-dot-rogers-store-finder.appspot.com/searchFidoStoresService',
      sqlColumns: [
        'Record_ID',
        'SCID',
        'Fido_Credit_Cards',
        'Corporate_Store',
        'Store_Name',
        'Phone',
        'TV_Sales',
        'Int_Sales',
        'Priority1',
        'Priority2',
        'Priority3',
        'New_apple_device_1',
        'New_apple_device_2',
        'New_promo_device_1',
        'New_promo_device_2',
        'Gplus_URL',
        'Address',
        'Address2',
        'City',
        'country',
        'Province',
        'Postal_Code',
        'Intersection',
        'Telephone_No',
        'Fax_No',
        'Cell_Phone',
        'Pager',
        'Email',
        'Movies_and_Games_For_Rent',
        'Hi_Def_For_Sale',
        'Hi_Def_For_Rent',
        'Games_For_Sale',
        'Rogers_Portable_Internet',
        'Rogers_Video_Store',
        'Rogers_Plus_Store',
        'Accessories',
        'Vouchers',
        'Loaner_Phone_Service',
        'Mobile_Exchange',
        'Payment_All',
        'Payment_CCOnly',
        'Fido_Trade',
        'Fido_Check_In',
        'Home_Phone_Sales',
        'Stores_Kioskos',
        'Retail_Partners',
        'TV_Pickup_Exch',
        'Int_Pickup_Exch',
        'Gift_cards',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
        'Monday_FR',
        'Tuesday_FR',
        'Wednesday_FR',
        'Thursday_FR',
        'Friday_FR',
        'Saturday_FR',
        'Sunday_FR',
        'Latitude',
        'Longitude'
      ],
      // mapSearchOpenHours: {
      //   en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      //   fr: ['Monday_FR', 'Tuesday_FR', 'Wednesday_FR', 'Thursday_FR', 'Friday_FR', 'Saturday_FR', 'Sunday_FR']
      // },
      // mapSearchDistance: ['geometry', 'ST_DISTANCE(geometry,ST_POINT([userLng],[userLat])) AS distance'],
      tmpSearchCategory: [
        { serviceName: 'Phones and SIM Card', serviceValue: 'Phone' },
        { serviceName: 'Eclipse Sales', serviceValue: 'Eclipse_Sales' },
        { serviceName: 'Unlocking phone', serviceValue: 'unlockPhone' }
      ],
      retryLimit: 6, // Since our initial search is distance is 5km and we are doubling it up to 160km
      initialSearchDistance: 160, //CH-4584
      // Query Related
      selectString: 'select=',
      whereString: '&where=',
      orderString: '&order=distance ASC',
      channelIDString: '&channelID=FIDO'
    })
    .factory('storeLocatorService', [
      'storeLocatorConfig',
      '$http',
      'env',
      function(storeLocatorConfig, $http, env) {
        /**
         * Store Locator Ajax Services
         */

        var request = {
          /**
           * It is used to call google map server to get the store list from search query.
           * @param searchStr
           * @returns {HttpPromise}
           */
          search: function(searchStr) {
            return $.ajax({
              type: 'POST',
              url: storeLocatorConfig.storeLocatorUrl,
              data: searchStr,
              dataType: 'json',
              success: function(mapData) {
                // noop
              },
              error: function() {
                // noop
              }
            });

            //TODO fix this

            /*  return      $http({
           url: storeLocatorConfig.storeLocatorUrl,
           data: searchStr,
           method: 'POST',
           dataType: 'json',
           headers: {
           'Content-Type': 'application/x-www-form-urlencoded',
           }
           });*/
          }
        };

        return request;
      }
    ])
    .directive('storeLocator', [
      'uiGmapIsReady',
      'storeLocatorConfig',
      'storeLocatorService',
      '$document',
      '$compile',
      '$templateCache',
      '$location',
      '$window',
      '$rootScope',
      '$state',
      'uteLocale',
      function(
        uiGmapIsReady,
        storeLocatorConfig,
        storeLocatorService,
        $document,
        $compile,
        $templateCache,
        $location,
        $window,
        $rootScope,
        $state,
        uteLocale
      ) {
        return {
          restrict: 'AE',
          templateUrl: 'modules/core/views/store-locator.html',
          scope: {
            selectedLocation: '=?', // store location user selected. This object contains all the properties google returns from the fido table
            selectedPosition: '=?', // same as selected-location, but it only returns selected google's geometry.location API.
            searchLimitCount: '=?', // passing maximum stores to be found from the searched location.
            initialDisplayMap: '=?', // boolean to display map before user start searching store locations. Default is true meaning the map will be visible even before user start searching the store locations.
            initialSearchLocation: '=?', // passing the search location. If it is provided, searching store locations near initial-search-location will be started as soon as google map is instantiated.
            initialSearchPosition: '=?', // same as initial-search-location, but it will be google's geometry.location API.
            initialSearchCategories: '=?', // passing search categories in javascript array. For eclipse project, there is only 'Eclipse_Sales' is passing for search category.
            showSearchbox: '=?', // boolean to notify store locator to show search location input or not.
            //showPagination: '=?',
            idKey: '=?',
            showSearchCategory: '=?' // boolean to notify store locator to show search categories to select. Eclipse project only has one search category, so we don't have to show it until we have more than one categories.
          },
          link: function(scope) {
            var map = {};
            /* place has to be set as google's geometry.location object */
            var place = null;
            /* array to hold all the searched store locations plus the location user typed. First object is the user typed location */
            var markers = [];
            /* Search  */
            var selectedSearchCategoryValues = [];
            var startLoc = { lat: storeLocatorConfig.defaultLat, lng: storeLocatorConfig.defaultLng };

            var searchDistance = storeLocatorConfig.initialSearchDistance;
            if (scope.idKey === undefined) {
              scope.idKey = 1;
            }
            // default google map options
            scope.map = {
              center: { latitude: storeLocatorConfig.defaultLat, longitude: storeLocatorConfig.defaultLng },
              pan: true,
              zoom: storeLocatorConfig.defaultZoom,
              refresh: storeLocatorConfig.refresh
            };
            scope.options = storeLocatorConfig.defaultOptions;
            scope.searchCategories = storeLocatorConfig.tmpSearchCategory;
            scope.infoWindow = null;
            scope.displaySearchbox = storeLocatorConfig.defaultShowSearchbox;
            //scope.displayPagination = storeLocatorConfig.defaultShowPagination;
            scope.defaultShowSearchCategory = storeLocatorConfig.defaultShowSearchCategory;
            $state.current.name === 'pickupAtStore'
              ? (scope.showMap = !storeLocatorConfig.defaultShowMap)
              : (scope.showMap = storeLocatorConfig.defaultShowMap);
            // for exchange hardware modal
            scope.showReminder = false;
            if (typeof scope.showSearchbox !== 'undefined') scope.displaySearchbox = scope.showSearchbox;
            //if(typeof scope.showPagination !== "undefined")
            //  scope.displayPagination = scope.showPagination;
            if (typeof scope.showSearchCategory !== 'undefined')
              scope.defaultShowSearchCategory = scope.showSearchCategory;
            if (typeof scope.initialDisplayMap !== 'undefined') scope.showMap = scope.initialDisplayMap;
            var events = {
              /**
               * function to generate select query string based on fido table in google server.
               * It go through all the default columns in storeLocatorConfig values and generate single search query string to pass to Ajax call.
               */
              // getSelectMapString: function () {

              //   var currentLanguage = currentLanguage || uteLocale.language;

              //   function getStr(arr) {
              //     var str = '';
              //     _.forEach(arr, function (v) {
              //       str += encodeURIComponent(v) + ',';
              //     });
              //     return str;
              //   }

              //   function getDistanceStr() {
              //     var str = '';
              //     _.forEach(storeLocatorConfig.mapSearchDistance, function (v) {
              //       str += v + ',';
              //     });
              //     return str;
              //   }

              //   var hasLanguageChanged = false;
              //   if (currentLanguage !== uteLocale.language) {
              //     hasLanguageChanged = true;
              //     currentLanguage = uteLocale.language;
              //   }
              //   this.selectStr = this.selectStr || 'select=' + getStr(storeLocatorConfig.sqlColumns);
              //   this.openHourStr = hasLanguageChanged ? getStr(storeLocatorConfig.mapSearchOpenHours[currentLanguage]) : (this.openHourStr || getStr(storeLocatorConfig.mapSearchOpenHours[currentLanguage]));
              //   this.distanceStr = this.distanceStr || getDistanceStr();
              //   console.log(this.selectStr);
              //   console.log(this.openHourStr);

              //   return (this.selectStr + this.openHourStr).replace(/,\s*$/, '');
              // },

              // searchLocation: function () {
              //   if (!place)
              //     return;

              //   if (!scope.showMap)
              //     scope.showMap = true;
              //   if (!scope.showReminder)
              //     scope.showReminder = true;

              //   // remove previous markers from google map
              //   for (var i = 0, marker; marker = markers[i]; i++) {
              //     marker.setMap(null);
              //   }

              //   // reset marker array
              //   markers = [];
              //   startLoc.lat = place.lat();
              //   startLoc.lng = place.lng();

              //   var searchQuery = this.searchGoogleTable();
              //   this.requestGoogleTable();
              // },

              /**
               * generating select query to pass the query string to google server.
               */
              // searchGoogleTable: function () {
              //   if (scope.infoWindow)
              //     scope.infoWindow.close();
              //   var selectStr = this.getSelectMapString();
              //   selectStr = selectStr.replace('[userLng]', startLoc.lng).replace('[userLat]', startLoc.lat);

              //   var whereStr = '';
              //   if (selectedSearchCategoryValues.length > 0) {
              //     for (var i = 0; i < selectedSearchCategoryValues.length; i++)
              //       whereStr += "\"" + selectedSearchCategoryValues[i] + "\"%3D'Y'" + "AND"
              //     whereStr = '&where=' + whereStr.replace(/AND$/g, ''); // REMOVE "AND" FROM END OF WHERE STRING
              //   }

              //   // ORDER STRING

              //   var orderStr = orderStr || '&order=' + encodeURIComponent('distance ASC');
              //   var varLatitude = startLoc.lat;
              //   var varLongitude = startLoc.lng;

              //   selectStr = selectStr + ",CONCAT(Longitude, ',' ,Latitude) as geometry,( 6371 * acos( cos( radians(" + varLatitude + ") ) * cos( radians(Latitude) ) * cos( radians( Longitude ) - radians(" + varLongitude + ") )%2Bsin( radians(" + varLatitude + ") ) * sin( radians( Latitude )))) AS distance";

              //whereStr = "&where=(Int_Sales='Y' AND Priority1='Y' AND ( 6371 * acos( cos( radians(" + varLatitude + ") ) * cos( radians(Latitude) ) * cos( radians( Longitude ) - radians(" + varLongitude + ") )%2Bsin( radians(" + varLatitude + ") ) * sin( radians( Latitude ))))%3C" + distance + ")OR(Int_Sales='Y'AND Priority2='Y'AND ( 6371 * acos( cos( radians(" + varLatitude + ") ) * cos( radians(Latitude) ) * cos( radians( Longitude ) - radians(" + varLongitude + ") )%2Bsin( radians(" + varLatitude + ") ) * sin( radians( Latitude ))))%3C" + distance + ")OR(Int_Sales='Y'AND Priority3='Y'AND ( 6371 * acos( cos( radians(" + varLatitude + ") ) * cos( radians(Latitude) ) * cos( radians(Longitude) - radians(" + varLongitude + ")) %2B sin( radians(" + varLatitude + ") ) * sin( radians( Latitude ))))%3C" + distance + ")OR(Int_Sales='Y'AND Priority10='Y'AND ( 6371 * acos( cos( radians(" + varLatitude + ") ) * cos( radians(Latitude) ) * cos( radians( Longitude ) - radians(" + varLongitude + ") )%2Bsin( radians(" + varLatitude + ") ) * sin( radians( Latitude ))))%3C" + distance + ")";
              //     // google search location string based on user typed location near by 20km of distance.
              //     var searchQuery = selectStr + whereStr + orderStr + '&channelID=FIDO' + '&limit=' + (scope.searchLimitCount ? (scope.searchLimitCount < storeLocatorConfig.defaultMaxResults ? scope.searchLimitCount : storeLocatorConfig.defaultMaxResults) : storeLocatorConfig.defaultMaxResults);
              //   console.info(searchQuery, 'searchQuery');
              //this.requestGoogleTable(searchQuery);

              // },
              /**
               * http request to google server based on searchQuery provided.
               * @param searchQuery - query string for fetching store locations
               */
              // requestGoogleTable: function (searchQuery) {
              //   var that = this;
              //   storeLocatorService.search(searchQuery).success(function (data, status, header, config) {
              //       if (data && data.features) {
              //         for (var i = 0; i < data.features.length; i++)
              //           data.features[i].properties.idx = i + 1;
              //         scope.storeList = data.features;
              //         scope.pages = [];
              //         if (scope.storeList && scope.storeList.length > 0)
              //           scope.searchMode = 'search-mode';
              //         if (scope.storeList.length > 3) {
              //           var pageSize = parseInt(scope.storeList.length / 3);
              //           if (scope.storeList.length % 3 > 0)
              //             pageSize++;
              //           if (pageSize > 1) {
              //             for (var i = 0; i < pageSize; i++) {
              //               scope.pages.push({ num: i + 1 });
              //             }
              //             scope.selectedPage = 1;
              //           }
              //         }
              //         that.renderLocationOnMap();
              //       }
              //       else {
              //         console.log('no search result!');
              //         // Todo
              //         // display no search result
              //       }
              //     })
              //     .error(function (data, status, headers, config) {
              //       console.log(data);
              //     });
              // },

              /**
               * function to pre-select map search categories, or just add the new category value to category list for fetching from fido table
               * @param value
               */
              toggleSearchCategory: function(value) {
                var idx = selectedSearchCategoryValues.indexOf(value);
                if (idx > -1) selectedSearchCategoryValues.splice(idx, 1);
                else selectedSearchCategoryValues.push(value);
              },

              /**
               *
               *CH-3456 Story Changes start
               * This function recursively calls the google store locator 6 times or untill the search distance is not more than 160km.
               * Here the searchDistance is doubled at every retry starting with 5km.
               * This function uses closures and identity combinator as explained in http://willseitz-code.blogspot.com/2016/04/retry-mechanism-for-javascript.html
               */
              searchLocationUntilFound: function() {
                // check whtether if calling multiple times results in error
                var self = this;

                if (!place) {
                  console.log('Place is empty');
                  return [];
                }

                if (scope.infoWindow) {
                  scope.infoWindow.close();
                }

                scope.showMap = scope.showMap ? true : false;
                scope.showReminder = scope.showReminder ? true : false;

                // remove previous markers from google map
                if (markers.length) {
                  for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                  }
                }
                markers = [];
                startLoc = {
                  lat: place.lat(),
                  lng: place.lng()
                };

                // Setting the retry limit
                var timesToRetry = storeLocatorConfig.retryLimit;

                /**
                 * We are constructing a parial query which is returned by a function that takes searchDistance
                 * as an input and returns a complete query. (closure mechanism is used)
                 */
                var constructQuery = function() {
                  // Select clause construct
                  var selectString = storeLocatorConfig.selectString;

                  for (var i = 0; i < storeLocatorConfig.sqlColumns.length; i++) {
                    selectString += storeLocatorConfig.sqlColumns[i];
                    selectString += ',';
                  }
                  // distance string construct
                  var radiusString = '(6371 * acos(cos(radians(';
                  radiusString +=
                    startLoc.lat + ') ) * cos( radians(Latitude) ) * cos( radians( Longitude ) - radians(';
                  radiusString +=
                    startLoc.lng + ') ) %2B sin( radians(' + startLoc.lat + ') ) * sin( radians( Latitude ))))';

                  selectString += radiusString + 'AS distance, ';

                  selectString += 'CONCAT(Longitude, ' + "'" + ',' + "'" + ' ,Latitude) as geometry';

                  // partial Where clause contruct

                  var whereString = storeLocatorConfig.whereString;

                  var priority1 = "(Int_Sales = 'Y' AND Priority1 = 'Y' AND " + radiusString + '<';
                  var priority2 = "(Int_Sales = 'Y' AND Priority2 = 'Y' AND " + radiusString + '<';
                  var priority3 = "(Int_Sales = 'Y' AND Priority3 = 'Y' AND " + radiusString + '<';
                  var priority10 = "(Int_Sales = 'Y' AND Priority10 = 'Y' AND " + radiusString + '<';

                  var limitString =
                    '&limit=' +
                    (scope.searchLimitCount
                      ? scope.searchLimitCount < storeLocatorConfig.defaultMaxResults
                        ? scope.searchLimitCount
                        : storeLocatorConfig.defaultMaxResults
                      : storeLocatorConfig.defaultMaxResults);

                  console.log('Limit::whereClause::', limitString, whereString);
                  return function(distance) {
                    var completeQueryString = selectString;
                    completeQueryString += whereString;
                    completeQueryString += priority1 + distance + ') OR';
                    completeQueryString += priority2 + distance + ') OR';
                    completeQueryString += priority3 + distance + ') OR';
                    completeQueryString += priority10 + distance + ') ';
                    completeQueryString +=
                      storeLocatorConfig.orderString + limitString + storeLocatorConfig.channelIDString;

                    return completeQueryString;
                  };
                };

                // Calculates a partial construct query and
                // retuns a function takes searchDistance as input and constructs a complete query.
                var constructCompleteQuery = constructQuery();

                return function(distance) {
                  var fetchStoreLocations = function(searchDistance) {
                    var gMapResponse = [];
                    if (timesToRetry < 1) {
                      self.processResult(gMapResponse);
                      return gMapResponse;
                    } else {
                      timesToRetry--;
                      var searchQuery = constructCompleteQuery(searchDistance);
                      return storeLocatorService
                        .search(searchQuery)
                        .success(function(data, status, header, config) {
                          if (data && data.features) {
                            gMapResponse = data.features;

                            /**
                             * gMapResponse array is not empty, then we are returning the response.
                             * In case of any error occured, we are stopping the recursion and returning empty response
                             */
                            if (gMapResponse.length) {
                              console.log(gMapResponse, gMapResponse.length);
                              self.processResult(gMapResponse);
                              return gMapResponse;
                            } else {
                              var newSearchDistance = searchDistance + searchDistance;
                              return fetchStoreLocations(newSearchDistance);
                            }
                          }
                        })
                        .error(function(data, status, headers, config) {
                          /**
                           * In case of error, we are not recursively calling the fetchStoreLocations fn, instead
                           * we are returning empty array as result, thus completing the function execution.
                           */
                          gMapResponse = [];
                          console.error('Store Locator Call Failed', data);
                          self.processResult(gMapResponse);
                          return gMapResponse;
                        });
                    }
                  };
                  return fetchStoreLocations(distance);
                };
              },
              /**
               * starting point for search store locations. it validates the user selected place is exist, then to get the store list from the user location.
               */
              searchLocation: function() {
                // Returns a function that triggers call to the store locator, recursively untill the first store is found.
                var availableStoresFn = this.searchLocationUntilFound();
                console.log("Initidal distance==>", storeLocatorConfig.initialSearchDistance);
                availableStoresFn(storeLocatorConfig.initialSearchDistance);
              },

              // processes the available stores returned by storeLocatorAPI
              processResult: function(availableStores) {
                if (availableStores && availableStores.length) {
                  /*** CH-4584 BEGIN */
                  var match = [];
                  for (var j = 0; j < availableStores.length; j++) {
                    //match[j].properties.openStore = "No";
                    /*if (availableStores[j].properties.Sunday != "CLOSED" && availableStores[j].properties.Monday != "CLOSED" && availableStores[j].properties.Tuesday != "CLOSED" && availableStores[j].properties.Wednusday != "CLOSED" && availableStores[j].properties.Friday != "CLOSED" && availableStores[j].properties.Saturday != "CLOSED" ) {
                      console.log("In If Day==>", current_day);
                      match.push(availableStores[j]);
                    } */
                    if (availableStores[j].properties.Store_Name !== "Fido: CLOSED/FERMÉ") {
                      match.push(availableStores[j]);
                    }
                  }
                  console.log('Filter array==>', match);
                  for (var i = 0; i < match.length; i++) match[i].properties.idx = i + 1;
                  scope.storeList = match;
                  /** END OF CH-4584 */
                  //for (var i = 0; i < availableStores.length; i++) availableStores[i].properties.idx = i + 1;
                  //scope.storeList = availableStores;
                  scope.pages = [];
                  if (scope.storeList && scope.storeList.length > 0) scope.searchMode = 'search-mode';
                  if (scope.storeList.length > 3) {
                    var pageSize = parseInt(scope.storeList.length / 3);
                    if (scope.storeList.length % 3 > 0) pageSize++;
                    if (pageSize > 1) {
                      for (var i = 0; i < pageSize; i++) {
                        scope.pages.push({ num: i + 1 });
                      }
                      scope.selectedPage = 1;
                    }
                  }
                  this.renderLocationOnMap();
                } else {
                  console.log('no search result!');

                  scope.storeList = match;
                  scope.pages = [];
                  this.renderLocationOnMap();
                  // Todo
                  // display no search result
                }
              },

              // *CH-3456 Story Changes end

              /**
               * rendering all the location returned from google server on the map.
               */
              renderLocationOnMap: function() {
                scope.isDirectionMode = false;

                // adding user location first
                if (place) {
                  var image = {
                    url: 'http://maps.gstatic.com/mapfiles/place_api/icons/geocode-71.png',
                    size: new google.maps.Size(71, 71),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 34),
                    scaledSize: new google.maps.Size(25, 25)
                  };

                  var marker = new google.maps.Marker({
                    map: map,
                    icon: image,
                    title: 'Searched Location',
                    position: place
                  });

                  markers.push(marker);

                  this.centerMap(marker);

                  // adding searched locations
                  for (var i = 0, store; (store = scope.storeList[i]); i++) {
                    var lat = store.geometry.coordinates[1];
                    var lng = store.geometry.coordinates[0];
                    var storeLatLng = new google.maps.LatLng(lat, lng);
                    var storeImg = new google.maps.MarkerImage(
                      'http://www.fido.ca/cms/html/storelocator/images/markers/number_' + (i + 1) + '.png',
                      new google.maps.Size(32, 37),
                      new google.maps.Point(0, 0)
                    );
                    var storeMarker = new google.maps.Marker({
                      map: map,
                      icon: storeImg,
                      title: store.properties['Store_Name'],
                      position: storeLatLng,
                      info: store.properties,
                      storeMarkerNum: i + 1
                    });
                    markers.push(storeMarker);
                    this.bindMarkerEvent(storeMarker);
                  }

                  // bound obj to extend the google map bound to cover markers
                  var bounds = new google.maps.LatLngBounds();
                  for (var i = 0; i < markers.length; i++) bounds.extend(markers[i].getPosition());
                  map.fitBounds(bounds);
                }
              },
              /**
               * function to hook mouse events to store marker.
               * @param storeMarker
               */
              bindMarkerEvent: function(storeMarker) {
                // MARKER CLICK EVENT
                var that = this;
                google.maps.event.addListener(storeMarker, 'click', function() {
                  that.generateInfoWindow(storeMarker, true);
                });
                google.maps.event.addListener(map, 'mouseout', function() {
                  if (scope.infoWindow) scope.infoWindow.close();
                });
              },
              /**
               * when user clicks store point on the map, this function is called to show popup info window.
               * @param storeInfo
               * @param focusStore
               */
              generateInfoWindow: function(storeInfo, focusStore) {
                scope.selectedLocation = storeInfo.info;
                var lat = storeInfo.position.lat();
                var lng = storeInfo.position.lng();
                scope.selectedPosition = { lat: lat, lng: lng };

                if (scope.infoWindow) scope.infoWindow.close();
                var HTMLContent = $templateCache.get('infoWindow.html');
                HTMLContent = HTMLContent.replace(/\[storeName\]/g, storeInfo.info['Store_Name'])
                  .replace(/\[storeAddress\]/g, storeInfo.info['Address'])
                  .replace(/\[storeCity\]/g, storeInfo.info['City'])
                  .replace(/\[storeProvince\]/g, storeInfo.info['Province'])
                  .replace(/\[storePostal\]/g, storeInfo.info['Postal_Code'])
                  .replace(/\[storePhone\]/g, storeInfo.info['Telephone_No'])
                  .replace(/\[storeDistance\]/g, (parseFloat(storeInfo.info['distance']) / 1000).toFixed(2))
                  .replace(/\[storeServices\]/g, '')
                  .replace(/\[storeIdx\]/g, storeInfo.info['idx'] - 1)
                  .replace(/\[storeMarkerNum\]/g, storeInfo.info['storeMarkerNum']);
                var compiled = $compile(HTMLContent)(scope);

                scope.infoWindow = new google.maps.InfoWindow({
                  content: compiled[0],
                  pixelOffset: new google.maps.Size(0, -33)
                });
                scope.infoWindow.setPosition(storeInfo.position);
                scope.infoWindow.open(map);

                if (focusStore) {
                  this.focusStoreForMap(storeInfo.info['idx'], true);
                  this.changeCurrentPageNumber(storeInfo.info['idx']);
                }
              },
              /**
               * calculating current page number and set selected page.
               * @param num
               */
              changeCurrentPageNumber: function(num) {
                var newSelectedPage = parseInt(num / 3);
                if (parseInt(num) % 3) newSelectedPage++;
                scope.selectedPage = newSelectedPage;
              },
              /**
               * function to move the center of the map to store pointer.
               * @param storeIdx - Index of store list which user selected.
               */
              centerMapForStore: function(storeIdx) {
                var storeMarker = markers[storeIdx + 1];
                this.centerMap(storeMarker);
                this.generateInfoWindow(storeMarker, false);
                this.changeCurrentPageNumber(storeIdx + 1);
              },
              /**
               * function to auto scroll the store list to show the store info user selected from the map.
               * @param storeInfoIdx
               * @param activeList
               */
              focusStoreForMap: function(storeInfoIdx, activeList) {
                if (scope.selectedInfoWindowStoreId)
                  document.getElementById(scope.selectedInfoWindowStoreId).classList.remove('active');
                scope.selectedInfoWindowStoreId = 'store_' + storeInfoIdx;
                var el = document.getElementById(scope.selectedInfoWindowStoreId);
                el.parentNode.parentNode.scrollTop = 0;
                var parentElTop = el.parentNode.parentNode.scrollTop * -1;
                var parentHeight = el.parentNode.offsetHeight;
                var containerHeight = el.parentNode.parentNode.parentNode.offsetHeight;
                var maxTopAllowedPosition = parentHeight - containerHeight + parentElTop;

                if (maxTopAllowedPosition > 0) maxTopAllowedPosition *= -1;

                var positionToMove = parentElTop + el.offsetTop;
                if (positionToMove < maxTopAllowedPosition) positionToMove = maxTopAllowedPosition;

                el.parentNode.parentNode.scrollTop = positionToMove;
                if (activeList) el.classList.add('active');
              },
              /**
               * set store list to scroll first store.
               */
              resetStoreListTopOffset: function() {
                if (scope.selectedInfoWindowStoreId)
                  document.getElementById(scope.selectedInfoWindowStoreId).classList.remove('active');
              },
              /**
               * rendering direction based on selected store
               * @param $index - store index from store list. It starts with 0.
               */
              renderDirection: function($index) {
                scope.isDirectionMode = true;
                this.selectedTravelMode = this.selectedTravelMode || google.maps.DirectionsTravelMode.DRIVING;

                if ($index > -1) scope.selectedStore = markers[$index + 1];
                this.directionsService = this.directionsService || new google.maps.DirectionsService();

                if (!this.directionsDisplay) {
                  this.directionsDisplay = new google.maps.DirectionsRenderer({ draggable: true });
                }

                this.directionsDisplay.setMap(map);

                if (this.directionRequest) {
                  this.directionRequest.destination = scope.selectedStore.position;
                  this.directionRequest.travelMode = this.selectedTravelMode;
                } else {
                  this.directionRequest = {
                    origin: markers[0].position,
                    destination: scope.selectedStore.position,
                    travelMode: this.selectedTravelMode
                  };
                }

                var that = this;
                this.directionsService.route(this.directionRequest, function(result, status) {
                  if (status === google.maps.DirectionsStatus.OK) {
                    that.directionsDisplay.setDirections(result);
                    that.directionsDisplay.setPanel(document.getElementById('direction-intro'));
                  }
                });
              },
              /**
               * setting direction mode display change. There are four mode available and they are driving, public transit, walking, bicycling.
               * @param mode - transit mode user selected.
               */
              changeTravelMode: function(mode) {
                switch (mode) {
                  case 0:
                    this.selectedTravelMode = google.maps.DirectionsTravelMode.DRIVING;
                    break;
                  case 1:
                    this.selectedTravelMode = google.maps.DirectionsTravelMode.TRANSIT;
                    break;
                  case 2:
                    this.selectedTravelMode = google.maps.DirectionsTravelMode.WALKING;
                    break;
                  case 3:
                    this.selectedTravelMode = google.maps.DirectionsTravelMode.BICYCLING;
                    break;
                }
                this.renderDirection(-1);
              },
              /**
               * function to hide direction on the map.
               */
              closeDirectionMode: function() {
                scope.isDirectionMode = false;
                this.directionsDisplay.setMap(null);
              },
              /**
               * function to go to page number provided.
               * @param num - page number.
               */
              goToPage: function(num) {
                scope.selectedPage = num;
                this.focusStoreForMap((num - 1) * 3 + 1, false);
              },
              /**
               * getting place by location string
               * @param locationStr
               */
              getPlace: function(locationStr) {
                var request = {
                  location: locationStr,
                  radius: 500,
                  types: ['geocode']
                };
                var initialLoc = new google.maps.places.PlacesService(map);
                initialLoc.nearbySearch(request, function(result, status) {
                  if (status == google.maps.places.PlacesServiceStatus.OK) {
                    place = result[0].geometry.location;
                    scope.events.searchLocation();
                  }
                });
              },
              /**
               * function to move the center of the map to provided marker position.
               * it also moves the center of the map to right side if store list is on left, so the center of the map is properly centered between the visible map area.
               * @param marker - point to set it as the center of the map
               */
              centerMap: function(marker) {
                if (!google.maps.Map.prototype.setCenterWithOffset) {
                  google.maps.Map.prototype.setCenterWithOffset = function(latlng, offsetX, offsetY) {
                    var map = this;
                    var ov = new google.maps.OverlayView();
                    ov.onAdd = function() {
                      var proj = this.getProjection();
                      var aPoint = proj.fromLatLngToContainerPixel(latlng);
                      aPoint.x = aPoint.x - offsetX;
                      aPoint.y = aPoint.y + offsetY;
                      map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
                    };
                    ov.draw = function() {};
                    ov.setMap(this);
                  };
                }
                var deviceSize = _ute.device.size;
                var offsetx = 0;
                if (deviceSize === 'lg' || deviceSize === 'xl') {
                  var storeLocatorWidth = parseInt(
                    (document.getElementsByClassName('store-locator-container')[0].clientWidth * 0.25) / 2
                  );
                  if (storeLocatorWidth > 0) offsetx = storeLocatorWidth;
                }
                map.setCenterWithOffset(marker.position, offsetx, 0);
              },
              /**
               * function to recalculate pagination when screen size changes.
               */
              handlePagination: function() {
                scope.displayPagination = false;
                //this.renderPagination();
                //var w = angular.element($window);
                //var that = this;
                //w.on('resize', function(){
                //  that.renderPagination();
                //});
              },
              /**
               * function to decide showing or hiding pagination based on device size.
               */
              renderPagination: function() {
                //var deviceSize = $document[0].body.attributes['ute-device-size'].value;
                //if(deviceSize == "xs" || deviceSize == "sm")
                //  scope.displayPagination = true;
                //else
                //  scope.displayPagination = false;
              },
              /**
               * function to watch screen size change, then call mobile view to handle the map and store list position.
               */
              handleMobileView: function() {
                this.renderMobileView();
                var that = this;
                scope.$watch(
                  function() {
                    return _ute.device.size;
                  },
                  function() {
                    that.renderMobileView();
                  }
                );
                //var w = angular.element($window);
                //var that = this;
                //w.on('resize', function(){
                //  that.renderMobileView();
                //});
              },
              /**
               * rendeing mobile view.
               */
              renderMobileView: function() {
                //var deviceSize = _ute.device.size;
                //if(deviceSize == "xs" || deviceSize == "sm")
                //  scope.displayMode = scope.displayMode || 'mobile';
                //else
                //  scope.displayMode = null;
              }
            };

            scope.events = events;

            scope.switchDisplayMode = function(mode) {
              scope.displayMode = mode;
              scope.$broadcast(scope.displayMode);
            };

            /**
             * following function is called when google map is instantiated. otherwise store locator won't properly handle the settings provided from outside of scope.
             */

            console.warn(scope.idKey);

            uiGmapIsReady.promise(scope.idKey).then(function(instances) {
              var i = 0;
              instances.forEach(function(inst) {
                if (inst.instance == scope.idKey) {
                  // setting map to instantiated google map object.
                  map = inst.map;
                  // after map is instantiated, we need to pass the following options.
                  map.setOptions({
                    panControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT },
                    zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP }
                  });
                  // When store locator directive has initial search input value to start with, it will automatically search using google map API, then display it to the map.
                  var searchInput = $('.storeSearch')[i];

                  var autocomplete = new google.maps.places.Autocomplete(searchInput);
                  google.maps.event.addListener(autocomplete, 'place_changed', function() {
                    console.info(autocomplete);
                    var rawPlace = autocomplete.getPlace();
                    if (rawPlace && rawPlace.formatted_address) {
                      scope.searchedValue = rawPlace.formatted_address.replace(', Canada', '');
                      place = rawPlace.geometry.location;
                      events.searchLocation();
                    }
                  });

                  if (scope.initialSearchCategories && scope.initialSearchCategories.length > 0) {
                    _.forEach(scope.initialSearchCategories, function(v) {
                      events.toggleSearchCategory(v);
                    });
                  }

                  if (scope.initialSearchPosition) {
                    console.log('Called by Initial Search position');
                    place = new google.maps.LatLng(scope.initialSearchPosition.lat, scope.initialSearchPosition.lng);
                    events.searchLocation();
                  } else if (scope.initialSearchLocation) {
                    console.log('Called by Initial Search Location');
                    var service = new google.maps.places.AutocompleteService();
                    service.getQueryPredictions({ input: scope.initialSearchLocation }, function(predictions, status) {
                      if (status == google.maps.places.PlacesServiceStatus.OK) {
                        var geocoder = new google.maps.Geocoder();
                        geocoder.geocode({ address: predictions[0].description }, function(results, status) {
                          if (status == google.maps.GeocoderStatus.OK) {
                            place = results[0].geometry.location;
                            events.searchLocation();
                          }
                        });
                      }
                    });
                  }
                  //events.handlePagination();
                  //events.handleMobileView();
                }
                i++;
              });
            });
          }
        };
      }
    ]);
})();
